import { createPinia } from 'pinia';
import piniaPluginPersistedState from 'pinia-plugin-persistedstate';
import { createApp } from 'vue';
import { useSentry } from 'src/shared/integrations/sentry';
import { Typography } from 'src/shared/ui';
import { TOASTS_ENABLED } from 'src/shared/constants';
import Toaster, { type ToastContainerOptions } from 'vue3-toastify';

import App from 'src/main.vue';
import router from 'src/router';

import 'modern-normalize/modern-normalize.css';
import 'unfonts.css';
import 'src/main.css';
import 'src/responsive.css';
import 'vue3-toastify/dist/index.css';

const app = createApp(App);
const pinia = createPinia();
pinia.use(piniaPluginPersistedState);
useSentry(app, router);
app.use(pinia);
app.use(router);
if (TOASTS_ENABLED) {
  app.use(Toaster, {
    position: 'bottom-center',
    autoClose: 10000,
    hideProgressBar: true,
    dangerouslyHTMLString: true,
  } as ToastContainerOptions);
}
app.component('typography', Typography);

app.mount('#app');
